import { render, staticRenderFns } from "./MenuLink.vue?vue&type=template&id=beb33170&"
import script from "./MenuLink.ts?vue&type=script&lang=ts&"
export * from "./MenuLink.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports